// @flow
import React from 'react';
import radium from 'radium';
import { Row, Col, ListGroup } from 'react-bootstrap/lib';
import styler from 'react-styling';

import { ContactAvatar, PhoneLink } from './index';
import breakpoints from '../../css/breakpoints';

const style = styler`
    Container
      background-color: #FFF
      margin-top: 40px
      max-width: 950px
      padding: 40px 40px 20px 40px
      @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
        padding: 20px
        margin-top: 20px
    Icon
      font-size: 20px
      color: #0A152D
      text-align: center
      float: left
      @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
        font-size: 16px
    Specs
      color: #666
      padding-right: 0
    Wordbreak
      word-break: break-all
    ImageContainer
      padding: 0
      width: 210px
      height: 210px
      float: right
      @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
        float: left
        height: 18vh
        width: 18vh
        position: relative
        left: 50%
        transform: translateX(-50%)
        margin-right: -15px
    Image
      border-radius: 50%
      float: right
      height: 100%
      width: 100%
    Avatar
      text-align: center
      font-size: 40px
      border-radius: 50%
      float: right
      height: 200px
      width: 100%
      padding: 0 15px
    Listgroup
      width: 100%
      margin-bottom: 0
    ListGroupItem
      border: 0
      margin-bottom: 0
      font-size: 18px
      margin-bottom: 20px
      @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
        font-size: 14px
  `;

type Props = {
  languagedata: Object,
  contact: {
    mobile: string,
    email: string,
    city: string,
    title: string,
    department: string,
    city: string,
    displayName: string,
  }
};

export const Card = (props: Props) => {
  const lang = props.languagedata;

  return (
    <div style={style.Container}>
      <Row>
        <Col xs={12} sm={8} lg={8}>
          <ListGroup style={style.Listgroup}>
            <div style={style.ListGroupItem}><Row>
              <Col xs={1} className="fa fa-phone" style={style.Icon} />
              <Col xs={3} style={style.Specs}>
                {lang.mobile}:
              </Col>
              <Col xs={7} style={style.Wordbreak}><PhoneLink phone={props.contact.mobile} /></Col>
            </Row></div>
            <div style={style.ListGroupItem}><Row>
              <Col xs={1} className="fa fa-envelope-o" style={style.Icon} />
              <Col xs={3} style={style.Specs}>
                {lang.email}:
              </Col>
              <Col xs={7} style={style.Wordbreak}>
                <a href={`mailto:${props.contact.email}`}>{props.contact.email}</a>
              </Col>
            </Row></div>
            <div style={style.ListGroupItem}><Row>
              <Col xs={1} className="fa fa-user" style={style.Icon} />
              <Col xs={3} style={style.Specs}>
                {lang.title}:
              </Col>
              <Col xs={7} style={style.Wordbreak}>{props.contact.title}</Col>
            </Row></div>
            <div style={style.ListGroupItem}><Row>
              <Col xs={1} className="fa fa-map-marker" style={style.Icon} />
              <Col xs={3} style={style.Specs}>
                {lang.city}:
              </Col>
              <Col xs={7} style={style.Wordbreak}>{props.contact.city}</Col>
            </Row></div>
            <div style={style.ListGroupItem}><Row>
              <Col xs={1} className="fa fa-building" style={style.Icon} />
              <Col xs={3} style={style.Specs}>
                {lang.department}:
              </Col>
              <Col xs={7} style={style.Wordbreak}>{props.contact.department}</Col>
            </Row></div>
          </ListGroup>
        </Col>
        <Col xs={12} sm={4} lg={4}>
          <div style={style.ImageContainer}>
            <ContactAvatar
              imagePath={props.contact.email ? `/contacts/photo/${props.contact.email}` : null}
              displayName={props.contact.displayName}
              style={style.Avatar}
              imageStyle={style.Image}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default radium(Card);



// WEBPACK FOOTER //
// ./src/js/Components/Card.js